<div kendoTooltip tooltipClass="kendo-tooltip" class="column-header-display">
  <div [title]="processedColumnTitle" class="grid-header-template header-display">
    <div class="title-position">{{ processedColumnTitle }}</div>
  </div>
</div>
